"use client";
import { jsxs as d, jsx as l } from "react/jsx-runtime";
const f = ({
  title: h,
  titleId: i,
  desc: a,
  descId: e,
  ...c
}) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-cv",
    viewBox: "0 0 640 480",
    "aria-labelledby": i,
    "aria-describedby": e,
    ...c,
    children: [
      a ? /* @__PURE__ */ l("desc", { id: e, children: a }) : null,
      h ? /* @__PURE__ */ l("title", { id: i, children: h }) : null,
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "cv-a", children: /* @__PURE__ */ l("path", { fillOpacity: 0.7, d: "M-123.4 0h682.6v512h-682.6z" }) }) }),
      /* @__PURE__ */ d(
        "g",
        {
          fillRule: "evenodd",
          clipPath: "url(#cv-a)",
          transform: "translate(115.7)scale(.94)",
          children: [
            /* @__PURE__ */ l("path", { fill: "#fff", d: "M-123.4 233H723v206h-846.5z" }),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#081873",
                d: "M-122.8 0h846v256.6h-846zm.3 385.9h852.1V512h-852.1z"
              }
            ),
            /* @__PURE__ */ l("path", { fill: "#de3929", d: "M-122.5 302.6h846v39.6h-846z" }),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#ffce08",
                d: "m131 399.2 6.6 20.4H159l-17.4 12.7 6.6 20.5L131 440l-17.4 12.7 6.7-20.5-17.4-12.7h21.5M317 250.4l6.7 20.5H345l-17.4 12.6 6.6 20.5-17.4-12.7-17.4 12.7 6.6-20.5-17.4-12.6h21.6m-222 64.4 6.6 20.5h21.5L99 368.6l6.7 20.4-17.4-12.6L70.9 389l6.6-20.4-17.4-12.7h21.5M317 329.5l6.7 20.4H345l-17.4 12.7 6.6 20.4-17.4-12.6-17.4 12.7 6.6-20.5-17.4-12.7h21.6m-40.5-161.7 6.7 20.4H298l-17.4 12.7 6.6 20.5-17.4-12.7-17.4 12.7 6.7-20.5-17.5-12.7h21.6m-64.5-45.2 6.7 20.5h21.5l-17.4 12.6 6.6 20.5-17.4-12.6-17.4 12.6 6.7-20.5-17.4-12.6H192m-64.5 2.9 6.7 20.5h21.5l-17.4 12.6 6.7 20.5-17.5-12.7-17.4 12.7 6.7-20.5-17.4-12.6H121m-34.8 43.2 6.6 20.5h21.6l-17.5 12.6 6.7 20.5-17.4-12.7-17.4 12.7 6.6-20.5L58 271h21.5m119.2 149.4 6.7 20.5h21.5l-17.4 12.6 6.7 20.5-17.5-12.7-17.4 12.7 6.7-20.5-17.4-12.6H192m82.2-41.7 6.6 20.4h21.5L285 432.3l6.7 20.5-17.4-12.7-17.5 12.7 6.7-20.5-17.4-12.7h21.5"
              }
            )
          ]
        }
      )
    ]
  }
);
export {
  f as default
};
